import { IFaqArticleSearchTag } from '../../faq.types'
import EditArticleSheet from '../../components/EditArticleSheet'
import faqApi from '../../faq.api'
import faqEvents from '../../events/faq.events'
import { useNavigate } from 'react-router'
import { useParams } from 'react-router-dom'
import useFaqArticle from '../../hooks/useFaqArticle'
import FaqStateProvider from '../../components/FaqStateProvider'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import Button from '../../../../../shared/Buttons/Button/Button'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import useFaqFormStateAndOptions from '../../hooks/useFaqFormState'

const EditArticle = () => {
  const params = useParams()
  const article = useFaqArticle(+params.id)

  const navigate = useNavigate()
  const { wait, loading } = useHttpLoader()
  const {
    state: [state, handleChange],
    checkpointsOptions,
    projectTypesOptions,
    projectStagesOptions,
  } = useFaqFormStateAndOptions({
    defaultValues: {
      ...article,
      searchTags: article.searchTags.map((tag) => tag.tag) as IFaqArticleSearchTag[],
    },
  })

  const handleSubmit = () => {
    wait(faqApi.updateArticle(article.id, { ...state, searchTags: state.searchTags.map((c) => c.id) }), (resp) => {
      if (resp.status === 'success') {
        faqEvents.articleUpdated(resp.body, article.id)
        navigate('/admin/knowledge-base')
      }
    })
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between panel-layout__content-header'>
          <div className='flex-lines' style={{ gap: '7px' }}>
            <h2 className='page--header inline-flex-gap' style={{ gap: '7px' }}>
              <span>Новая статья</span>
            </h2>
          </div>
        </div>
        <EditArticleSheet
          article={state}
          onChange={handleChange}
          projectStagesOptions={projectStagesOptions}
          projectTypesOptions={projectTypesOptions}
          checkpointsOptions={checkpointsOptions}
        >
          <div
            className='form-footer inline-flex-gap'
            style={{ justifyContent: 'flex-end', width: '100%', flexDirection: 'row' }}
          >
            <Button style={{ width: 'fit-content' }} theme='primary' onClick={handleSubmit} loading={loading}>
              Сохранить
            </Button>
          </div>
        </EditArticleSheet>
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default () => (
  <FaqStateProvider>
    <EditArticle />
  </FaqStateProvider>
)
